import { apiClient } from "../../../lib"

interface NotificationListProps {
    page: number;
    limit: number;
}

const API_BASE_URL = import.meta.env.VITE_APPLICATION_API || "https://localhost:8443";

export const notification = {
    getList: async ({ page, limit }: NotificationListProps) => {
        const response = await apiClient.get(`/notification/list?page=${page}&limit=${limit}`);
        return response.data.data; 
    },
    streamApi: `${API_BASE_URL}/notification/stream`
}